<template>
  <Modal class-name="vertical-center-modal"
         v-model="isRealName"
         title="实名认证">
    <div class="form-wrapper">
      <Form :model="realNameForm"
            label-position="right"
            :label-width="100"
            :rules="ruleValidate">
        <FormItem label="身份证号">
          <div class="form-group">
            <Input v-model="realNameForm.card_no" placeholder="请输入您的真实身份证号" />
          </div>
        </FormItem>
        <FormItem label="手机号">
          <div class="form-group">
            <Input v-model="realNameForm.mobile" placeholder="请输入您的手机号" />
          </div>
        </FormItem>
        <FormItem label="验证码">
            <div class="form-group ivu-col ivu-col-span-16" style="padding-right: 5px;">
              <Input v-model="realNameForm.code" placeholder="请输入验证码" />
            </div>
            <div class="ivu-col ivu-col-span-8" style="padding-left: 5px;">
              <span class="get-code">获取验证码</span>
            </div>
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn confirm-btn" @click="handelSubmit">提交</span>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal, Form, FormItem, Input } from 'view-design'
/* import { alipayAuth } from '@/api/auth' */
export default {
  name: "RealName",
  components: {
    Modal,
    Form,
    FormItem,
    Input
  },
  props: {
    /* info: {
      type: Object,
      default: {}
    }, */
  },
  created() {
    //console.log(this.info)
  },
  data: function () {
    return {
      isRealName: false,
      realNameForm: {
        card_no: '',
        mobile: '',
        code: '',
      },
      loading:false,
      ruleValidate: {}
    }
  },
  methods: {
    init: function () {
      this.isRealName = true
    },
    handelCancel: function () {
      this.isRealName = false
    },
    handelSubmit: function () {
      if(this.loading){
        return
      }
      if(!this.realNameForm.card_no){
        this.$Message.error('请填写身份证号')
        return
      }
      if(!this.realNameForm.mobile){
        this.$Message.error('请填写手机号')
        return
      }
      if(!this.realNameForm.code){
        this.$Message.error('请填写验证码')
        return
      }
      this.loading = true
      this.loading = false
      this.$Message.success('接口待接入')
      /* alipayAuth(this.realNameForm).then(response => {
        this.loading = false
        this.$Message.success(response.message)
        this.handelCancel();
      }).catch(error => {
        this.loading = false
        console.log(error)
      }) */
    }
  }
}
</script>

<style scoped>
.normal-font {
  color: #FF4F76;;
  font-size: 14px;
}
.get-code{
  display: block;
  height: 36px;
  line-height: 36px;
  border: 1px solid #D63036;
  color: #D63036;
  text-align: center;
}
>>> .ivu-modal-body {
  padding: 16px 16px 0px 16px;
}
>>> .ivu-modal-content{
  border-radius: 0;
}
>>> .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .vertical-center-modal .ivu-modal {
  top: 0;
}
>>> .ivu-input{
  border-radius: 2px;
  height: 36px;
}
>>> .form-wrapper .form-group .ivu-input:focus {
  border: 1px solid #D63036 !important;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(255, 150, 43, 0.6) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(255, 150, 43, 0.6) !important;
  outline: none;
}
>>> .form-wrapper .form-group .ivu-input:hover {
  border-color: #D63036;
}
>>> .vertical-center-modal .ivu-modal-footer {
  border-top: none;
  padding: 0px 18px 12px 18px;
  text-align: right;
}

.footer-wrapper {
  display: flex;
  min-width: 0;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.footer-wrapper .btn {
  display: inline-block;
  border-radius: 2px;
  margin-right: 10px;
  padding: 0px 20px;
  font-size: 14px;
  height: 36px;
  line-height: 36px;
  vertical-align: middle;
  cursor: pointer;
}
.footer-wrapper .btn.confirm-btn {
  background: #D63036;
  color: #fff;
}
.footer-wrapper .btn.cancel-btn {
  border: 1px solid #eeeeee;
  border-radius: 2px;
  color: #222222;
}
</style>



// WEBPACK FOOTER //
// src/components/kfc/Realname.vue